import { ReactComponent as DepartmentIcon } from "assets/DepartmentIcon.svg";
import { ReactComponent as ContentIcon } from "assets/ContentIcon.svg";
import { ReactComponent as TaskIcon } from "assets/TaskIcon.svg";
import { ReactComponent as BuildOutlined } from "assets/BuildOutlined.svg";
import {
  Box,
  ListItem,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { List } from "antd";
import React, { useEffect, useState } from "react";

type SearchResult = {
  value: string;
  section: string;
  value_id: string;
  icon: React.ReactNode;
};

const RECENT_SEARCH_KEY = "recentSearches";

type RecentSearchProps = {
  onSearchClick: (searchTerm: string) => void;
};

const RecentSearch: React.FC<RecentSearchProps> = ({ onSearchClick }) => {
  const [recentSearches, setRecentSearches] = useState<SearchResult[]>([
    {
      value: "AS Chemistry",
      section: "Subject Structure",
      value_id: "1",
      icon: <BuildOutlined />,
    },
    {
      value: "P Mathematics",
      section: "Content",
      value_id: "2",
      icon: <ContentIcon />,
    },
    {
      value: "Jody Mallinson",
      section: "Task",
      value_id: "3",
      icon: <TaskIcon />,
    },
    {
      value: "Simon Meaker",
      section: "Task",
      value_id: "4",
      icon: <TaskIcon />,
    },
    {
      value: "IG Geography",
      section: "Department",
      value_id: "5",
      icon: <DepartmentIcon />,
    },
    {
      value: "IG Spanish",
      section: "Content",
      value_id: "6",
      icon: <ContentIcon />,
    },
    {
      value: "AL IT",
      section: "Subject Structure",
      value_id: "7",
      icon: <BuildOutlined />,
    },
  ]);

  useEffect(() => {
    const storedSearches = localStorage.getItem(RECENT_SEARCH_KEY);
    if (storedSearches) {
      setRecentSearches(JSON.parse(storedSearches));
    }
  }, []);

  const handleSearchClick = (result: SearchResult) => {
    const newSearches = [
      result,
      ...recentSearches.filter((s) => s.value_id !== result.value_id),
    ].slice(0, 10);
    localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(newSearches));
    setRecentSearches(newSearches);

    onSearchClick(result.value);
  };

  return (
    <Box>
      <Typography className="recent-search-box-title" variant="h6" sx={{ marginBottom: "1rem", marginLeft:"50px" }}>
        Recent Searches
      </Typography>
      <div className="recent-search-card">
      <List>
        {recentSearches.map((result) => (
          
          <ListItem
            component="div"
            key={result.value_id}
            onClick={() => handleSearchClick(result)}
            sx={{ padding: "0.5rem 0" }}
          >
             <div className='result-list-item'>
          <div className="result-item-icon">
          <ListItemIcon>{result.icon}</ListItemIcon>
          </div>
          <div className="result-item-content">
              <div className="result-item-title">{result.value}</div>
              <div className="result-item-dsc">{result.section}</div>
          </div>
         </div>
          </ListItem>
        ))}
      </List>
      </div>
    </Box>
  );
};

export default RecentSearch;
